import { UseMutationOptions, useMutation } from '@tanstack/react-query'

import { ApiErrorResponse } from 'services/types'

import { requestAttestation } from '..'

/** mutation-cache: synced by the caller (useResults onSuccess): result details and activity queries */
export const useRequestAttestation = (resultId: string, options?: UseMutationOptions<void, ApiErrorResponse>) => {
  return useMutation<void, ApiErrorResponse>({
    mutationFn: () => requestAttestation(resultId),
    ...options
  })
}
